import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import MemberLayout from '../../components/MemberLayout';
import { Field, Logo, Spinner } from '../../components/ui';
import api, { errMsg } from '../../services/api';
import { useMember } from '../../context/AuthContext';

export default function Login() {
  const { member, signIn } = useMember();
  const navigate = useNavigate();
  const [form, setForm] = useState({ identifier: '', password: '' });
  const [busy, setBusy] = useState(false);

  if (member) return <Navigate to="/profile" replace />;

  const submit = async e => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post('/public/login', form);
      signIn(data.token, data.member);
      navigate(data.member.status === 'PENDING' ? '/verify-email' : '/profile');
    } catch (err) {
      toast.error(errMsg(err, 'Login failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <MemberLayout narrow>
      <div className="card p-7">
        <div className="mb-6 text-center">
          <Logo size={64} className="mx-auto" />
          <h1 className="mt-3 font-display text-3xl font-bold text-navy-900">Member log in</h1>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Email or NIC number">
            <input className="input" required value={form.identifier} onChange={e => setForm(f => ({ ...f, identifier: e.target.value }))} autoComplete="username" />
          </Field>
          <Field label="Password">
            <input type="password" className="input" required value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} autoComplete="current-password" />
          </Field>
          <div className="text-right text-sm"><Link to="/forgot-password" className="text-navy-700 hover:underline">Forgot password?</Link></div>
          <button type="submit" disabled={busy} className="btn-primary w-full py-2.5">{busy && <Spinner size={16} />}Log in</button>
        </form>
        <p className="mt-6 text-center text-sm text-gray-600">Not registered yet? <Link to="/register" className="font-medium text-navy-700 underline">Register now</Link></p>
      </div>
    </MemberLayout>
  );
}
